<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="hold-package"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
          <template v-slot:[`item.verified_at`]="{ item }">
            <div v-if="item.verified_at != null">
              {{ item.verified_at | moment("DD/MM/YYYY HH:mm:ss") }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <div v-if="item.created_at != null">
              {{ item.created_at | moment("DD/MM/YYYY HH:mm:ss") }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div class="py-0">
              <v-chip
                v-if="item.status === 'verified'"
                color="#4CAF50" small text-color="white"
              >{{ item.status }}</v-chip>
              <v-chip
                v-else-if="item.status === 'unverified'"
                color="#FD397A" small text-color="white"
              >{{ item.status }}</v-chip>
            </div>
          </template>
          <template v-slot:item.action="{ item }">
            <span
              v-if="item?.status === 'verified' && !hasVerification"
              class="action-hide-guard"
            />
          </template>
        </datatable>
      </div>
    </div>

    <form-action ref="form" module="hold-package" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="hold-package"
      :success="deleteSuccess"
    />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Hold Package" }
    ]);
  },
  data() {
    return {
      title: "Hold Package",
      url: "hold-package/data",
      columns: [
        { value: "id" },
        {
          text: "Member",
          value: "member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Tanggal Mulai Hold",
          value: "start_hold_date",
          sortable: true,
          searchable: true,
          formatter: v => (v ? this.$moment(v).format("DD/MM/YYYY") : "")
        },
        {
          text: "Tanggal Kembali",
          value: "return_date",
          sortable: true,
          searchable: true,
          formatter: v => (v ? this.$moment(v).format("DD/MM/YYYY") : "-")
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          searchable: true
        },
        {
          text: "Verified At",
          value: "verified_at",
          sortable: true,
          searchable: false,
          formatter: v => (v ? this.$moment(v).format("DD/MM/YYYY HH:mm:ss") : "-")
        },
        {
          text: "Created At",
          value: "created_at",
          sortable: true,
          searchable: false,
          formatter: v => (v ? this.$moment(v).format("DD/MM/YYYY HH:mm:ss") : "-")
        }
      ]
    };
  },
  computed: {
    hasVerification() {
      return this.$store.getters.hasPermission("hold-package", "verification");
    }
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      if (item?.status === "verified" && !this.hasVerification) {
        this.$swal.fire({
          icon: "info",
          title: "Tidak Diizinkan",
          text: "Data yang sudah diverifikasi tidak dapat diubah/dihapus oleh akun Anda.",
          showConfirmButton: true
        });
        return;
      }
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>

<style scoped>
::v-deep td .action-hide-guard ~ * {
  display: none !important;
}
</style>
